import * as React from 'react'

interface Props {
  triggerComponent: JSX.Element
  toggleOpen: (contentId: string) => void
  open: boolean
  height: string
  triggerHeight: string
  contentId: string
  mobile: boolean
  children?: React.ReactNode
}

export const Collapsible: React.FC<Props> = props => {
  const triggerComponent = props.triggerComponent
  return (
    <div
      className="collapsibe"
      style={{
        height: props.height,
        maxHeight: props.open ? (props.mobile ? 'none' : props.height) : props.triggerHeight,
        transition: 'all 0.3s ease',
        overflow: 'hidden'
      }}
    >
      <div
        style={{display: 'flex', justifyContent: 'end', alignItems: 'center', cursor: 'pointer'}}
        onClick={() => {
          props.toggleOpen(props.contentId)
        }}
      >
        {triggerComponent}
      </div>
      <div className="collapsible-content" style={{height: `calc(100% - ${props.triggerHeight})`}}>
        {props.children}
      </div>
    </div>
  )
}
